/**
 * @generated SignedSource<<c746c61acf43e5ae58af553c5c367457>>
 * @relayHash 1cd9026561f4402b952e3100eece2978
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02e1ab887d6abc611a827d2e60318c7419ad65281f62563e625c24d23b272a91

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSpaPageContainerQuery$variables = {
  cloudId: string;
};
export type JiraSpaPageContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
};
export type JiraSpaPageContainerQuery = {
  response: JiraSpaPageContainerQuery$data;
  variables: JiraSpaPageContainerQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider: {
    readonly get: () => boolean;
  };
});

import bannerAnnouncementViaSpa_provider from '@atlassian/jira-relay-provider/src/banner-announcement-via-spa.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "BannerContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraAnnouncementBanner",
                "kind": "LinkedField",
                "name": "announcementBanner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visibility"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "02e1ab887d6abc611a827d2e60318c7419ad65281f62563e625c24d23b272a91",
    "metadata": {},
    "name": "JiraSpaPageContainerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
    }
  }
};
})();

(node as any).hash = "cceab149c27c13616adc23f0556d61ac";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
